import { makeStyles } from '@material-ui/core';

import { sanitizeUrl } from 'Utils/sanitizeUrl';

import { buildOfficeOnlineEmbedUrl } from '../../constants';

const useStyles = makeStyles({
  frame: {
    flex: 1,
    width: '100%',
    minHeight: 0,
    border: 0,
    borderRadius: 12,
    background: '#EEF0F2'
  }
});

interface OfficeContentProps {
  url: string;
  name: string;
}

/** Word / Excel / PowerPoint rendered by the Office Online viewer in a frame. */
export const OfficeContent = ({ url, name }: OfficeContentProps) => {
  const classes = useStyles();

  return (
    <iframe
      className={classes.frame}
      src={buildOfficeOnlineEmbedUrl(sanitizeUrl(url))}
      title={name}
      allowFullScreen
    />
  );
};
